import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import InputMask from "react-input-mask";
import {
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiLock,
  FiUpload,
  FiCalendar,
} from "react-icons/fi";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
const TicketEdit = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);

  const [userData, setUserData] = useState([]);

  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isRequeteAccordionOpen, setIsRequeteAccordionOpen] = useState(true);
  const toggleRequeteAccordion = () => {
    setIsRequeteAccordionOpen(!isRequeteAccordionOpen);
  };
  const [isSuiviAccordionOpen, setIsSuiviAccordionOpen] = useState(true);
  const toggleSuiviAccordion = () => {
    setIsSuiviAccordionOpen(!isSuiviAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  //Pièce jointe
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  // Hashtag #
  const [selectedHashTag, setSelectedHashTag] = useState("");
  // Titre de la requete
  const [selectedTitreRequete, setSelectedTitreRequete] = useState("");
  const handleTitreRequeteChange = (event) => {
    setSelectedTitreRequete(event.target.value);
  };
  // Type de la requete
  const [selectedTypeRequete, setSelectedTypeRequete] = useState("");
  const [typeRequeteData, setTypeData] = useState({ data: [] });
  const handleTypeRequeteChange = (event) => {
    setSelectedTypeRequete(event);
  };
  const getTypeRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_types`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTypeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeRequeteOptions = () => {
    return [
      {
        options: typeRequeteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Description
  const [selectedDescription, setSelectedDescription] = useState("");
  const handleDescriptionChange = (event) => {
    setSelectedDescription(event.target.value);
  };
  // Url
  const [selectedUrl, setSelectedUrl] = useState("");
  const handleUrlChange = (event) => {
    setSelectedUrl(event.target.value);
  };
  // Criticite
  const [selectedCriticite, setSelectedCriticite] = useState("");
  const [criticiteData, setCriticiteData] = useState({ data: [] });
  const handleCriticiteChange = (event) => {
    setSelectedCriticite(event);
  };
  const getCriticite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/criticities`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCriticiteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCriticiteOptions = () => {
    return [
      {
        options: criticiteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Compte
  const [selectedCompte, setSelectedCompte] = useState("");
  const [compteData, setCompteData] = useState({ data: [] });
  const handleCompteChange = (event) => {
    setSelectedCompte(event.target.value);
  };
  const getCompte = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCompteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCompteOptions = () => {
    return [
      {
        options: compteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Commentaire
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (event) => {
    setSelectedCommentaire(event.target.value);
  };
  // Budget
  const [selectedBudget, setSelectedBudget] = useState("");
  const handleBudgetChange = (event) => {
    setSelectedBudget(event.target.value);
  };
  // StatutLiv
  const [selectedStatutLiv, setSelectedStatutLiv] = useState("");
  const [statutLivData, setSelectedStatutLivData] = useState({ data: [] });
  const handleStatutLivChange = (event) => {
    setSelectedStatutLiv(event);
  };
  const getStatutLiv = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/delivery_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutLivData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutLivOptions = () => {
    return [
      {
        options: statutLivData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // StatutReq
  const [selectedStatutReq, setSelectedStatutReq] = useState("");

  const [statutReqData, setSelectedStatutReqData] = useState({ data: [] });
  const handleStatutReqChange = (event) => {
    setSelectedStatutReq(event);
  };
  const getStatutRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutReqData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutReqOptions = () => {
    return [
      {
        options: statutReqData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Temps
  const [selectedTemps, setSelectedTemps] = useState("");
  const handleTempsChange = (event) => {
    setSelectedTemps(event.target.value);
  };
  // DateLiv
  const [selectedDateLiv, setSelectedDateLiv] = useState("");
  // DateCorr
  const [selectedDateCorr, setSelectedDateCorr] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Tickets | EDIT";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails Ticket"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedTitreRequete === "" ||
      selectedDescription === "" ||
      selectedTypeRequete === null ||
      selectedCriticite === null ||
      selectedUrl === "" ||
      selectedCompte === ""
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        setLoading(true);

        const formData = new FormData();

        formData.append("id", id);
        formData.append("name", selectedTitreRequete);
        formData.append("fx_ticket_type_id", selectedTypeRequete?.value || "");
        formData.append("criticity", selectedCriticite?.value || "");
        formData.append("url", selectedUrl);
        formData.append("description", selectedDescription);
        formData.append("delivery_status", selectedStatutLiv?.value || "");
        selectedCommentaire
          ? formData.append("commentaires_support", selectedCommentaire)
          : null;
        formData.append("spent_time", selectedTemps);
        formData.append("budget", selectedBudget);
        formData.append("fichier", selectedFichier);
        formData.append("role_or_account_used", selectedCompte);
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets/${id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.fx_ticket_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.fx_ticket_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets/${id}/edit`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const userData = await response.json();
        setUserData(userData);
        setSelectedHashTag(userData?.detail_fx_ticket?.["Requête"]?.["#"]);
        setSelectedTitreRequete(
          userData?.detail_fx_ticket?.["Requête"]?.["Titre de la requête"]
        );
        setSelectedTypeRequete(
          userData?.detail_fx_ticket?.["Requête"]?.["Type de requête"]
        );
        setSelectedCommentaire(
          userData?.detail_fx_ticket?.["Requête"]?.["Commentaires support"]
        );
        setSelectedCompte(
          userData?.detail_fx_ticket?.["Requête"]?.["Compte utilisé"]
        );
        setSelectedCriticite(
          userData?.detail_fx_ticket?.["Requête"]?.["Criticité"]
        );
        setSelectedDescription(
          userData?.detail_fx_ticket?.["Requête"]?.["Description"]
        );
        setSelectedFichier(
          userData?.detail_fx_ticket?.["Requête"]?.["Pièce jointe"]
        );
        setSelectedUrl(userData?.detail_fx_ticket?.["Requête"]?.["URL du bug"]);
        setSelectedBudget(
          userData?.detail_fx_ticket?.["Suivi"]?.["Budget (h)"]
        );
        setSelectedDateLiv(
          userData?.detail_fx_ticket?.["Suivi"]?.["Date de livraison"]
        );
        setSelectedDateCorr(
          userData?.detail_fx_ticket?.["Suivi"]?.["Date de correction"]
        );
        setSelectedStatutLiv(
          userData?.detail_fx_ticket?.["Suivi"]?.["Statut de livraison"]
        );
        setSelectedStatutReq(
          userData?.detail_fx_ticket?.["Suivi"]?.["Statut de la requête"]
        );
        setSelectedTemps(
          userData?.detail_fx_ticket?.["Suivi"]?.["Temps passé (h)"]
        );
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
        await getTypeRequete();
        await getStatutRequete();

        await getCriticite();
        await getStatutLiv();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/fx_tickets/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Tickets
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        userData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="12">
                              {userData?.detail_fx_ticket?.["Requête"] ? (
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleRequeteAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Requête
                                      </span>
                                    </div>
                                    {isRequeteAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isRequeteAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          userData?.detail_fx_ticket?.[
                                            "Requête"
                                          ] || {}
                                        ).map(([key, value], index) => {
                                          // Configuration des champs
                                          const fieldConfig = {
                                            "#": {
                                              value: selectedHashTag,
                                              handler: null,
                                              required: false,
                                              disabled: true,
                                              type: "input",
                                            },
                                            "Titre de la requête": {
                                              value: selectedTitreRequete,
                                              handler: handleTitreRequeteChange,
                                              required: true,
                                              disabled: false,
                                              type: "input",
                                            },
                                            "Type de requête": {
                                              value: selectedTypeRequete,
                                              handler: handleTypeRequeteChange,
                                              required: true,
                                              disabled: false,
                                              type: "select",
                                              options: renderTypeRequeteOptions,
                                            },
                                            "Compte utilisé": {
                                              value: selectedCompte,
                                              handler: handleCompteChange,
                                              required: true,
                                              disabled: false,
                                              type: "input",
                                            },
                                            "Commentaires support": {
                                              value: selectedCommentaire,
                                              handler: handleCommentaireChange,
                                              required: false,
                                              disabled: false,
                                              type: "input",
                                              show: type_compte == "builder",
                                            },
                                            "URL du bug": {
                                              value: selectedUrl,
                                              handler: handleUrlChange,
                                              required: true,
                                              disabled: false,
                                              type: "input",
                                            },
                                            Description: {
                                              value: selectedDescription,
                                              handler: handleDescriptionChange,
                                              required: true,
                                              disabled: false,
                                              type: "textarea",
                                            },
                                            "Pièce jointe": {
                                              value: value,
                                              handler: handleFichierChange,
                                              required: false,
                                              disabled: false,
                                              type: "file",
                                            },
                                            Criticité: {
                                              value: selectedCriticite,
                                              handler: handleCriticiteChange,
                                              required: true,
                                              disabled: false,
                                              type: "select",
                                              options: renderCriticiteOptions,
                                            },
                                          };

                                          const config = fieldConfig[key];
                                          if (!config || config.show === false)
                                            return null;

                                          const isInvalid = config.required;

                                          return (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft: isInvalid
                                                  ? "3px solid #dc3545"
                                                  : "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }
                                              }}
                                            >
                                              <Row
                                                className={
                                                  config.type === "textarea"
                                                    ? "align-items-start g-1"
                                                    : "align-items-center g-1"
                                                }
                                              >
                                                <Col xs={12} md={4}>
                                                  <div
                                                    className={`d-flex align-items-center small text-muted ${
                                                      config.type === "textarea"
                                                        ? "pt-1"
                                                        : ""
                                                    }`}
                                                  >
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      {key}
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  {config.type === "input" && (
                                                    <div
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        type="text"
                                                        value={config.value}
                                                        onChange={
                                                          config.handler
                                                        }
                                                        disabled={
                                                          config.disabled
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            config.disabled
                                                              ? "#e9ecef"
                                                              : "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                          cursor:
                                                            config.disabled
                                                              ? "not-allowed"
                                                              : "text",
                                                        }}
                                                      />
                                                      {config.disabled ? (
                                                        <FiLock
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.6,
                                                          }}
                                                        />
                                                      ) : (
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      )}
                                                    </div>
                                                  )}

                                                  {config.type ===
                                                    "textarea" && (
                                                    <div
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <textarea
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        rows={5}
                                                        value={config.value}
                                                        onChange={
                                                          config.handler
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          resize: "vertical",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "8px",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  )}

                                                  {config.type === "select" && (
                                                    <>
                                                      <Select
                                                        value={
                                                          config.value?.label ==
                                                          null
                                                            ? null
                                                            : config.value
                                                        }
                                                        onChange={
                                                          config.handler
                                                        }
                                                        options={config.options()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        styles={styles(
                                                          config.value === null
                                                        )}
                                                      />
                                                    </>
                                                  )}

                                                  {config.type === "file" && (
                                                    <>
                                                      {value != null && (
                                                        <a
                                                          href={value}
                                                          download
                                                          className="d-block mb-2 small text-primary"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                          }}
                                                        >
                                                          <i className="bx bx-file me-1"></i>
                                                          Voir le fichier
                                                        </a>
                                                      )}
                                                      <div className="position-relative">
                                                        <input
                                                          type="file"
                                                          onChange={
                                                            config.handler
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiUpload
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </>
                                                  )}
                                                </Col>
                                              </Row>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              ) : null}
                            </Col>
                            <Col sm="12">
                              <Row>
                                {/* {userData?.detail_fx_ticket?.[
                                  "Fil de discussion"
                                ] ? (
                                  <DiscussionThread
                                    messages={
                                      userData?.detail_fx_ticket?.[
                                        "Fil de discussion"
                                      ]
                                    }
                                  />
                                ) : null} */}
                              </Row>
                            </Col>
                            <Row></Row>

                            <Row>
                              <Col sm="12">
                                {" "}
                                {userData?.detail_fx_ticket?.Suivi ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleSuiviAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Suivi
                                        </span>
                                      </div>
                                      {isSuiviAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse isOpen={isSuiviAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            userData?.detail_fx_ticket?.Suivi ||
                                              {}
                                          ).map(([key, value], index) => {
                                            // Configuration des champs
                                            const fieldConfig = {
                                              "Budget (h)": {
                                                value: selectedBudget,
                                                handler: handleBudgetChange,
                                                required: false,
                                                disabled: false,
                                                type: "input",
                                              },
                                              "Date de correction": {
                                                value: selectedDateCorr,
                                                handler: setSelectedDateCorr,
                                                required: false,
                                                disabled: false,
                                                type: "date",
                                              },
                                              "Date de livraison": {
                                                value: selectedDateLiv,
                                                handler: setSelectedDateLiv,
                                                required: false,
                                                disabled: false,
                                                type: "date",
                                              },
                                              "Temps passé (h)": {
                                                value: selectedTemps,
                                                handler: handleTempsChange,
                                                required: false,
                                                disabled: false,
                                                type: "input",
                                              },
                                              "Statut de la requête": {
                                                value: selectedStatutReq,
                                                handler: null,
                                                required: false,
                                                disabled: true,
                                                type: "input",
                                              },
                                              "Statut de livraison": {
                                                value: selectedStatutLiv,
                                                handler: handleStatutLivChange,
                                                required: false,
                                                disabled: false,
                                                type: "select",
                                                options: renderStatutLivOptions,
                                              },
                                            };

                                            const config = fieldConfig[key];
                                            if (!config) return null;

                                            return (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    {config.type ===
                                                      "input" && (
                                                      <div
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          type="text"
                                                          value={config.value}
                                                          onChange={
                                                            config.handler
                                                          }
                                                          disabled={
                                                            config.disabled
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              config.disabled
                                                                ? "#e9ecef"
                                                                : "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                            cursor:
                                                              config.disabled
                                                                ? "not-allowed"
                                                                : "text",
                                                          }}
                                                        />
                                                        {config.disabled ? (
                                                          <FiLock
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.6,
                                                            }}
                                                          />
                                                        ) : (
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        )}
                                                      </div>
                                                    )}

                                                    {config.type === "date" && (
                                                      <div
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={config.value}
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          onChange={(e) => {
                                                            config.handler(
                                                              e.target.value
                                                            );
                                                          }}
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    )}

                                                    {config.type ===
                                                      "select" && (
                                                      <Select
                                                        value={
                                                          config.value?.label ==
                                                          null
                                                            ? null
                                                            : config.value
                                                        }
                                                        onChange={
                                                          config.handler
                                                        }
                                                        options={config.options()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        styles={styles(false)}
                                                      />
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default TicketEdit;
